export default __webpack_public_path__ + "static/media/red-aircraft.c904818f.png";